import { useQuery } from '@apollo/client'
import { filter, includes, map, sortBy, uniqBy } from 'lodash'
import PropTypes from 'prop-types'

import { fromGlobalId } from 'utils/transformations/graphql'

import { Loader } from 'components/Core'
import ErrorPage from 'components/Error/ErrorPage'

import FavoritesComponent from './Favorites.component'
import { passportFavoritesQuery } from './queries'
import { allTradeshowBrandsData } from './utils'

const LOCAL_STORAGE_KEY = 'JOOR_PASSPORT_FAVORITES'

const FavoritesUnloggedContainer = () => {
  const {
    data: eventData,
    loading: isLoadingData,
    error: isErrorData,
  } = useQuery(passportFavoritesQuery)

  const allBrands = isLoadingData ? [] : allTradeshowBrandsData(eventData)

  const getLocalStorage = () => {
    const lsSelections = localStorage.getItem(LOCAL_STORAGE_KEY)
    const lsSelectionsParsed =
      lsSelections !== null ? JSON.parse(lsSelections) : {}
    const filteredLocalStorage = filter(
      Object.entries(lsSelectionsParsed),
      ([, status]) => status,
    )
    return map(filteredLocalStorage, ([brandId]) => brandId)
  }

  const getFavoriteData = () => {
    const favoriteBrandIds = getLocalStorage()
    const brandMatches = allBrands
      .map((brand) => ({
        ...brand,
        id: fromGlobalId(brand.id).id,
        brandId: fromGlobalId(brand.id).id,
      }))
      .filter((brand) => includes(favoriteBrandIds, brand.id))
    const uniqueBrandMatches = uniqBy(brandMatches, (brand) => brand.id)
    const favorites = sortBy(uniqueBrandMatches, (brand) => brand.name)
    return favorites
  }

  const favoritedBrands = getFavoriteData()

  if (isLoadingData) return <Loader active useFullScreen />
  if (isErrorData) {
    return <ErrorPage content="the trade show data" />
  }

  return (
    <FavoritesComponent favoritedBrands={favoritedBrands} isLoggedIn={false} />
  )
}

FavoritesUnloggedContainer.propTypes = {
  trackEventBrandClick: PropTypes.func.isRequired,
}

export default FavoritesUnloggedContainer
